import { Button, Modal } from 'antd';
import ExclamationIcon from 'assets/icons/exclamation-circle-fill.svg';

interface props {
    open: boolean;
    onCancel: () => void | Promise<void>;
    onOk: () => void | Promise<void>;
    title?: string; // タイトルを外部から受け取る
    message?: string; // メッセージを外部から受け取る
    okText?: string; // OKボタンのテキスト
    okButtonStyle?: React.CSSProperties; // OKボタンのスタイル
}

export const ConfirmModalComponent = ({ open, onCancel, onOk,
}: props) => {

    return (
        <Modal width={327} open={open} footer={null} centered className="modal-info">
            <section style={{ paddingTop: 12, paddingBottom: 4 }}>
                <div style={{ width: '100%' }} className="center-inside">
                    <img src={ExclamationIcon} alt="" />
                </div>
                <div className="description-modal" style={{ marginBottom: 32, marginTop: 32 }}>
                    これから外部サービスに移行いたします。<br/>
                    本人確認の実施後、承認に１時間から数日要する場合がございます。それまではワンルームオークションでの続く操作はできませんので、しばらくおまちください。
                </div>
                <Button
                    type="primary"
                    className="button-login-text"
                    style={{ width: '100%', height: 48, }}
                    onClick={onOk}
                >
                    {"eKYC(外部サービス)へ進む"}
                </Button>
                <Button
                    className="button-login-text"
                    style={{ width: '100%', height: 48, border: "none"}}
                    onClick={onCancel}
                >
                    {"キャンセル"}
                </Button>
            </section>
        </Modal>
    );
};
